import { computed, reactive } from 'vue';
import { TimeUntilReservationEnds } from '../types';

const reservationTimeState = reactive<{
    showRemainingTimeNotice: boolean
    timeUntilReservationEnds: TimeUntilReservationEnds
    counter: number | undefined
}>({
    showRemainingTimeNotice: false,
    timeUntilReservationEnds: window.RESERVATION_STORE.timeUntilReservationEnds,
    counter: undefined,
});

export const useReservationTime = () => {
    const getTimeUntilReservationEndsInMinutes = () => {
        if (!reservationTimeState.timeUntilReservationEnds) {
            return 0;
        }

        return Math.floor(reservationTimeState.timeUntilReservationEnds / 60);
    };

    const reservationTimedOut = computed(() => reservationTimeState.timeUntilReservationEnds !== null && reservationTimeState.timeUntilReservationEnds <= 0);

    const stopCounter = () => {
        clearInterval(reservationTimeState.counter);
    };

    const decrease = () => {
        if (!reservationTimeState.timeUntilReservationEnds || reservationTimeState.timeUntilReservationEnds < 1) {
            return stopCounter();
        }

        reservationTimeState.timeUntilReservationEnds -= 1;
    };

    const startCounter = () => {
        reservationTimeState.counter = setInterval(decrease, 1000);
    };

    return {
        reservationTimeState,
        reservationTimedOut,
        getTimeUntilReservationEndsInMinutes,
        stopCounter,
        startCounter,
    };
};
